export const GenerateAuditSnapshotDownload = snapshot => {
  if (!snapshot) return;
  const json = JSON.stringify(snapshot, null, 2);
  const blob = new Blob([json], { type: "application/json;charset=utf-8;" });
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  const ts = (snapshot.generatedAt || new Date().toISOString()).replace(/[:.]/g, "-");
  link.href = url;
  link.download = `security-snapshot-${ts}.json`;
  document.body.appendChild(link);
  link.click();
  document.body.removeChild(link);
  URL.revokeObjectURL(url);
};
